import { blogCategoryFieldMapping } from "@qlik/qlik/src/lib/constants/blog-constants";
import { constructFilterQuery, fetchJsonResponse } from "@qlik/qlik/src/lib/services/util";
import { FUNCTIONS_PATH } from "@qlik/qlik/src/lib/constants/service-constants";

/**
 * Fetches a list of blog posts with applied filters.
 * @param {Object} filters - The filters to apply to the blog listing query.
 * @returns {Promise} - A promise that resolves to the response of the blog listing fetch request.
 */
const fetchBlogListing = async (filters, env = "main", preview = false) =>
    fetchJsonResponse(
        `${
            process.env.GATSBY_LISTING_API
        }${FUNCTIONS_PATH}/blog-listing?env=${env}&preview=${preview}&${constructFilterQuery(
            filters,
            blogCategoryFieldMapping
        )}`
    );

export { fetchBlogListing };
